// Registry of live CopilotController instances keyed by permission_id (the
// cloud_permission row id Denver uses as `active_perm`). Lets the sidebar's
// connection-close handler find the controller bound to the connection
// being closed without reaching into CopilotButton's React state.
//
// Single-active-session-per-user is enforced server-side, so in practice
// this map holds at most one entry per user at a time — but using a map
// keyed by permission_id keeps the lookup explicit and survives the
// transient case where a switch-and-restart leaves the old entry briefly
// alongside the new one before cleanup.
//
// Per specs/2026-05-15-copilot-connection-pinning-design.md § 7.

import { observable } from "mobx";

/** @type {Map<string, import("./CopilotController").CopilotController>} */
export const copilotControllers = observable.map();

/** Normalize the registry key — permission_ids come from React props
 *  (sometimes number, sometimes string) and from `active_perm` (string).
 *  Coerce to string so a numeric vs string permissionId never causes a miss. */
function key(permissionId) {
  return permissionId == null ? "" : String(permissionId);
}

export function registerController(permissionId, controller) {
  copilotControllers.set(key(permissionId), controller);
}

export function unregisterController(permissionId) {
  copilotControllers.delete(key(permissionId));
}

export function getController(permissionId) {
  return copilotControllers.get(key(permissionId)) || null;
}
